'use client';

import { LineChart, Line } from 'recharts';

interface SparklineProps {
  data: number[];
  width?: number;
  height?: number;
  color?: string;
}

export function Sparkline({ data, width = 60, height = 24, color }: SparklineProps) {
  if (!data || data.length < 2) return <div style={{ width, height }} />;

  const isPositive = data[data.length - 1] >= data[0];
  const strokeColor = color || (isPositive ? '#00C853' : '#FF1744');
  const chartData = data.map((value, i) => ({ i, value }));

  return (
    <div style={{ width, height }}>
      {/* Sized directly: ResponsiveContainer warns on its first render (it
          measures -1×-1 before ResizeObserver fires) and the dimensions here
          are already fixed, so measuring is pure overhead. */}
      <LineChart width={width} height={height} data={chartData}>
        <Line
          type="monotone"
          dataKey="value"
          stroke={strokeColor}
          strokeWidth={1}
          dot={false}
          isAnimationActive={false}
        />
      </LineChart>
    </div>
  );
}
